import { Event } from '~/Features/Messaging/types';

export class FormSubmitted extends Event {
    constructor(formId: string) {
        super(FormSubmitted.getMessageId(formId));
    }

    public static readonly getMessageId = (formId: string) => `FormSubmitted-${formId}`;
}
